import { Box } from "@material-ui/core";
import React from "react";
import { toArray } from "lodash";
import { useLocale } from "@hooks";
import { ConsultantOpportunityCardFragment } from "@graphql";
import { ColumnDescription } from "../kanban-board/kanban-types";

type Props = {
  column: ColumnDescription<ConsultantOpportunityCardFragment>;
};

export function ConsultantOpportunityColumnHeader({ column }: Props) {
  const { locale } = useLocale();

  let weeksTotal = 0;
  for (const card of column.cards) {
    const opportunity = card.issue.consultantOpportunity;

    weeksTotal += opportunity.isShared
      ? toArray(opportunity.weeks).length / 2
      : toArray(opportunity.weeks).length;
    weeksTotal += opportunity.isShared
      ? toArray(opportunity.weeksWon).length / 2
      : toArray(opportunity.weeksWon).length;
    weeksTotal += opportunity.isShared
      ? toArray(opportunity.weeksLost).length / 2
      : toArray(opportunity.weeksLost).length;
  }

  return (
    <Box
      className="react-kanban-column-header"
      display="flex"
      justifyContent="space-between"
    >
      <span style={{ cursor: "pointer" }}>
        {locale.consultantOpportunityBoardHeaders[column.title]}
      </span>
      <span style={{ whiteSpace: "nowrap" }}>
        {weeksTotal} {locale.Weeks.toLowerCase()}
      </span>
    </Box>
  );
}
